import './styles.scss';

import { Button, Layout } from 'antd';

import { useLogoutMutation } from '@/api/auth/api';

const { Header } = Layout;

export const TabletHeader = ({ user }: any) => {
  const [logout] = useLogoutMutation();

  return (
    <Header className="tablet-header">
      <div className="container">
        <div className="menu-text">
          Автоматизированная информационная система “Ветпротокол”
        </div>
        <div className="header-user-info">
          <span>{user?.fullName || ''}</span>
          <Button
            style={{ width: 144 }}
            type="primary"
            onClick={async () => {
              await logout();
            }}>
            Выйти
          </Button>
        </div>
      </div>
    </Header>
  );
};
